import PropTypes from 'prop-types';

import { momentOr } from 'utils/util';
import { workExperienceType, grades } from 'utils/enums';
import { Box, styled } from '@mui/material';
import { nimbleTheme } from 'theme';
import { getEmailAndPhoneText } from '../utils';

const TYPES = workExperienceType().reduce((obj, item) => {
  obj[item.value] = item.label;
  return obj;
}, {});

const GRADES = grades().reduce((obj, item) => {
  obj[item.value] = item.label;
  return obj;
}, {});

export default function WorkExperienceSection({ experiences }) {
  const renderLabels = (arr, mapping) => {
    /** take an array of enums and render as a string of labels according to the mapping */
    return arr.map((label) => mapping[label]).join(', ');
  };

  return (
    <Container className="simple-card-container">
      {experiences.map((row, i) => (
        <Card className="simple-card mb1" key={i}>
          {/* title section */}
          <div>
            <b>
              {row['title'] || ''}, {row['organization']['name'] || ''}
            </b>
          </div>

          {/* employment dates */}
          <div>
            <span>
              {row['start_date']
                ? `${momentOr(row['start_date'], 'M/D/YYYY', '')} - ${momentOr(
                    row['end_date'],
                    'M/D/YYYY',
                    'Present'
                  )}`
                : `${momentOr(row['end_date'], 'M/D/YYYY', 'Present')}`}
            </span>
          </div>

          {/* type of position */}
          {row.experience_types.length > 0 && (
            <div>
              <b>Type:</b>&nbsp; {renderLabels(row.experience_types, TYPES)}
            </div>
          )}

          {/* grades taught */}
          {row.grades.length > 0 && (
            <div>
              <b>Grade level:</b>&nbsp; {renderLabels(row.grades, GRADES)}
            </div>
          )}

          {/* reference information */}
          {row['reference_name'] ? (
            <div>
              <div>
                <b>Supervisor:</b>&nbsp; {row['reference_name']}
              </div>
              <div>{getEmailAndPhoneText(row['reference_email'], row['reference_phone'])}</div>
            </div>
          ) : null}

          {/* Job description */}
          {row['description'] ? (
            <div>
              <b>Job description:</b>&nbsp;
              {row['description']}
            </div>
          ) : null}

          {/* reason for leaving */}
          {row['reason_for_leaving'] ? (
            <div>
              <b>Reason for leaving job:</b>&nbsp; {row['reason_for_leaving']}
            </div>
          ) : null}
          {row.do_not_contact && <div className="bold">Please do not contact</div>}
        </Card>
      ))}
    </Container>
  );
}

WorkExperienceSection.propTypes = {
  experiences: PropTypes.arrayOf(Object).isRequired,
};

const Container = styled(Box)({
  '@media print': {
    columnCount: 2,
    display: 'block !important',
    flexWrap: 'none !important',
  },
});

const Card = styled(Box)({
  '@media print': {
    breakInside: 'avoid',
    paddingRight: nimbleTheme.spacing(2),
    width: '100% !important',
  },
});
